import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NotificationLegacy } from '@thiememeulenhoff/types';
import { NotificationLegacyEndpointService } from './notification-legacy.endpoint.service';

// TODO(TLA-9320): remove service once the API Gateway is migrated to the new API
@Injectable({
  providedIn: 'root',
})
export class NotificationLegacyService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(NotificationLegacyEndpointService);

  fetchNotifications(methodSlug: string | null = null) {
    const endpoint = methodSlug
      ? this.#endpoints.getNotificationsForMethod(methodSlug)
      : this.#endpoints.getNotifications();

    return this.#http.get<Array<NotificationLegacy>>(endpoint);
  }

  postNotificationSeen(notificationId: number) {
    return this.#http.post(
      this.#endpoints.getNotificationSeen(notificationId),
      {},
    );
  }

  postNotificationAllSeen(methodSlug: string, untilNotificationId: number) {
    return this.#http.post(
      this.#endpoints.getNotificationAllSeen(methodSlug, untilNotificationId),
      {},
    );
  }

  deleteNotification(notificationId: number) {
    return this.#http.delete(
      this.#endpoints.getnotificationDelete(notificationId),
    );
  }
}
